import PropTypes from 'prop-types';

const Geometry = {
  type: PropTypes.string,
  coordinates: PropTypes.arrayOf(
    PropTypes.oneOfType([
      PropTypes.arrayOf(
        PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.number), PropTypes.number])), PropTypes.number])
      ),
      PropTypes.arrayOf(PropTypes.number),
    ])
  ),
};

export const GeometryShape = PropTypes.shape(Geometry);
export const GeometryExact = PropTypes.exact(Geometry);
